<template>
    <div class="container-fluid w-100 d-flex flex-column">
        <div class="row flex-fill">
            <div class="col-xl-2 col-lg-3 col-md-4 py-3 border-right d-flex flex-column bg-white">
                <div class="flex-fill flex-shrink-0">
                    <slot name="form"></slot>
                </div>
            </div>
            <div class="col d-flex flex-column py-3 scrollable">
                <div class="row flex-shrink-0">
                    <div class="col-lg-8">
                        <h2>
                            {{ isTaxpayer && taxpayerInfo ? taxpayerInfo.name : $t($route.meta.title) }}
                        </h2>
                        <b-breadcrumb :items="breadcrumbs" class="p-0 bg-transparent" />
                    </div>
                    <div class="col-lg-4 d-flex align-items-center">
                        <div class="ml-auto py-3">
                            <slot name="createButton"></slot>
                        </div>
                    </div>
                </div>
                <div class="flex-shrink-0">
                    <slot name="createForm"></slot>
                </div>
                <slot name="workArea"></slot>
            </div>
        </div>        
    </div>
</template>

<script>
import AppData from '@/utils/appdata'

export default {
    name: 'BaseComponent',
    mixins: [ AppData ],
    props: {
        taxpayerInfo: Object
    },
    computed: {
        breadcrumbs: function () {
            var breadcrumbs = []
            if (this.$route.meta.breadcrumbs) {
                this.$route.meta.breadcrumbs.forEach(element => {
                    if (element.text === 'dealerName') {
                        breadcrumbs.push({
                            text: this.taxpayerInfo ? this.taxpayerInfo.name : null,
                            to: element.to,
                            active: element.active
                        })
                        return
                    }
                    if (element.text === 'reportName') {
                        breadcrumbs.push({ text: `${this.$t('menu.reportDetails')} ${this.$route.params.id}`, active: element.active, to: element.to })
                        return
                    }
                    breadcrumbs.push({ text: this.$t(element.text), to: element.to })
                })
            } else {
                this.$route.matched.slice().forEach(element => {
                    breadcrumbs.push({ text: this.$t(element.meta.title), to: { name: element.name } })
                })
            }
            return breadcrumbs
        }
    },
    watch: {
        taxpayerInfo: function (newVal) {
            this.taxpayerInfo = newVal
        }
    }
}
</script>
